//import firebase from 'firebase'
import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import * as Auth from './auth.js'
import Loader from '../ui/loader/Loader';
import backgroundImg from '../../images/background.jpg'
import { setTitle } from "../../actions"




let backgoundStyle = {
    'backgroundImage': `url('${backgroundImg}')`,
    'backgroundPosition': 'top center'
}

import logoImg from '../../images/logo_large.svg'
import googleSVG from "../../images/icons/googlebrands.svg"
import facebookSVG from "../../images/icons/facebook-f-brands.svg"
//import styles
import './styles/Signin.scss';

@connect((store) => {
    return { User: store.User, app: store.app }
})
class Signin extends React.Component {

    constructor(props) {
        super(props);
        this.doRedirectSignin = this.doRedirectSignin.bind(this)
        this.doRedirectSigninLink = this.doRedirectSigninLink.bind(this);
        this.doRedirectGoogleSignin = this.doRedirectGoogleSignin.bind(this);
        this.doRedirectFacebookSignin = this.doRedirectFacebookSignin.bind(this);

    }
    componentWillMount() {
        this.props.dispatch(setTitle('SpecialT'));

        if (this.props.User.User.uid) {
            this.props.router.replace('/home')
        }
    }

    componentDidMount() {
        setTimeout(() => {
            if (!this.props.User.User.loggedIn) {
                Auth.getRedirectResult()
            }
        }, 3000);
    }

    doRedirectGoogleSignin() {
        this.doRedirectSignin('Google');
    }

    doRedirectFacebookSignin() {
        this.doRedirectSignin('Facebook')
    }

    doRedirectSignin(p) {
        const { dispatch } = this.props;
        dispatch({
            type: 'SET_AUTHENTICATING',
            payload: true
        })

        Auth.doRedirectSignin(p)
        // .then((response) => {
        //     console.log(response);

        // }).catch((e) => {
        //     if (e.code === 'auth/account-exists-with-different-credential') {
        //         this.refs.signinButtons.style.display = 'none';
        //         this.refs.signinLinkButton.style.display = 'block';
        //         return
        //     }
        //     if (e) {
        //         console.log(e)
        //         alert(`Error with signup ${e.code}
        //         Message:${e.message}
        //         `)
        //         window.location.reload()
        //     }
        // });
    }

    doRedirectSigninLink(p) {
        Auth.doRedirectSigninLink(p).then((response) => {
            //this.props.router.push('/');
            console.log(response);
        })
    }

    render() {
        const { authenticating } = this.props.app;

        return (<main className="main large-header fancy-background" >
            <div className="app-header ">
                <img alt="SpecialT" src={logoImg} className="logo-t" />
            </div>
            {!authenticating && <div className="padding app-content">

                <div className="translucent-card">
                    <center>SpecialT is South Africa's first therapy app, carefully crafted to enhance the connection and teamwork between therapists and parents</center>
                    <center><hr /></center>
                    <div ref="signinButtons">
                        <button onClick={this.doRedirectGoogleSignin} className="signin-button google md-button md-raised ">
                            <img src={googleSVG} alt="Google Icon" /> Login or sign up with google
                        </button>
                        <button onClick={this.doRedirectFacebookSignin} className="signin-button facebook md-button md-raised ">
                            <img src={facebookSVG} alt="Facebook Icon" /> Login or sign up with facebook
                        </button>


                        <br />
                    </div>
                    <div ref="signinLinkButton" className="signin-link-button">
                        <p>
                            You have previously signed in with {this.props.User.existingProviderName}.Continue to link {this.props.User.newProviderName}
                            with {this.props.User.existingProviderName}.
                        </p>
                        <button onClick={this.doRedirectSigninLink} className={`signin-button ${this.props.User.existingProviderName} mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect`}>
                            Continue with {this.props.User.existingProviderName}
                        </button>
                    </div>
                </div>
                <div className="findOutMore">
                    <a href="http://specialt.co.za">Find out more about the app ></a>
                </div>
            </div>

            }
            {authenticating && <div className="padding app-content">
                <br /><br /><br /><br /><br /><br /><br /><br /><br />
                <div className="center">
                    <Loader />
                    <br />
                    <h6>Authenticating</h6>
                </div>
            </div>}
        </main>)
    }
}

export default withRouter(Signin);



// WEBPACK FOOTER //
// ./src/components/signin/Signin.jsx